import React from 'react';
import { useLocation } from 'react-router-dom';
import { UserFields } from './user_components/UserFields';

export default function EditUser() {
    const location = useLocation();
    return <UserFields pageTitle='edit_user' userInfo={location.state} />;
}
